import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-amber-500/10 bg-[#231e16] py-6"
    >
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="text-sm font-mono uppercase tracking-[0.3em] text-stone-500">{item}</span>
            <span className="mx-10 text-amber-400/70 text-xs">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
